/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstanceBulkLostRequest
 */
export interface InstanceBulkLostRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InstanceBulkLostRequest
     */
    lead_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkLostRequest
     */
    date_lost: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkLostRequest
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkLostRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the InstanceBulkLostRequest interface.
 */
export function instanceOfInstanceBulkLostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;
    isInstance = isInstance && "date_lost" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function InstanceBulkLostRequestFromJSON(json: any): InstanceBulkLostRequest {
    return InstanceBulkLostRequestFromJSONTyped(json, false);
}

export function InstanceBulkLostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkLostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'date_lost': json['date_lost'],
        'reason': json['reason'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function InstanceBulkLostRequestToJSON(value?: InstanceBulkLostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
        'date_lost': value.date_lost,
        'reason': value.reason,
        'comment': value.comment,
    };
}

